import type {
  HostedGameSnapshot,
  HostedPartySnapshot,
} from "@cue-the-night/transport";

import {
  HostedPartyClient,
} from "./hosted-party-client";

import {
  renderOwnerTruthOrDare,
  renderPlayerTruthOrDare,
} from "./truth-or-dare-ui";

import {
  renderOwnerHighOrLow,
  renderPlayerHighOrLow,
} from "./high-or-low-ui";

import {
  renderOwnerSecretAnswer,
  renderPlayerSecretAnswer,
} from "./secret-answer-ui";


export interface PlayerGameRenderOptions {
  readonly panel:
    HTMLElement;

  readonly party:
    HostedPartySnapshot;

  readonly game:
    HostedGameSnapshot;

  readonly participantId:
    string;

  readonly client:
    HostedPartyClient;

  readonly onGameSnapshot:
    (
      snapshot:
        HostedGameSnapshot,
    ) => void;
}


export interface OwnerGameRenderOptions {
  readonly panel:
    HTMLElement;

  readonly party:
    HostedPartySnapshot;

  readonly game:
    HostedGameSnapshot;
}


export function renderPlayerGame(
  options:
    PlayerGameRenderOptions,
): void {
  if (
    options.game.gameId ===
    "truth-or-dare"
  ) {
    renderPlayerTruthOrDare(
      options,
    );

    return;
  }

  if (
    options.game.gameId ===
    "high-or-low"
  ) {
    renderPlayerHighOrLow(
      options,
    );

    return;
  }

  if (
    options.game.gameId ===
    "secret-answer"
  ) {
    renderPlayerSecretAnswer(
      options,
    );

    return;
  }

  throw new Error(
    `Unsupported player game: ${options.game.gameId}`,
  );
}


export function renderOwnerGame(
  options:
    OwnerGameRenderOptions,
): void {
  if (
    options.game.gameId ===
    "truth-or-dare"
  ) {
    renderOwnerTruthOrDare(
      options,
    );

    return;
  }

  if (
    options.game.gameId ===
    "high-or-low"
  ) {
    renderOwnerHighOrLow(
      options,
    );

    return;
  }

  if (
    options.game.gameId ===
    "secret-answer"
  ) {
    renderOwnerSecretAnswer(
      options,
    );

    return;
  }

  throw new Error(
    `Unsupported owner game: ${options.game.gameId}`,
  );
}
